const hide = function (node) {
  node.hidden = true;
};

const displayNone = function (node) {
  node.style.display = 'none';
};

const displayReset = function (node) {
  node.style.display = '';
};

const show = function (node) {
  node.hidden = false;
};

const toggleVisiblity = function (node, shouldBeVisible) {
  if (shouldBeVisible) {
    show(node);
  } else {
    hide(node);
  }
};

const runWhenDomLoaded = (callback) => {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.kraut = window.kraut || {};

    if (window.kraut.runWhenDomLoaded) {
      window.kraut.runWhenDomLoaded.push(callback);
    } else {
      window.kraut.runWhenDomLoaded = [callback];

      document.addEventListener('readystatechange', (event) => {
        if (event.target.readyState === 'interactive') {
          // Sub-resources such as scripts, images, stylesheets and frames are still loading.
        } else if (event.target.readyState === 'complete') {
          window.kraut.runWhenDomLoaded.forEach((callback) => callback());
        }
      });
    }
  }
};

export {
  displayNone,
  displayReset,
  hide,
  show,
  toggleVisiblity,
  runWhenDomLoaded,
};
